import BusinessIcon from '@mui/icons-material/Business';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridViewIcon from '@mui/icons-material/CardGiftcard';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import LanguageIcon from '@mui/icons-material/Language';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import SettingsIcon from '@mui/icons-material/Settings';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MovieIcon from '@mui/icons-material/Movie';
import GroupsIcon from '@mui/icons-material/Groups';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsIcon from '@mui/icons-material/Payments';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalConvenienceStoreIcon from '@mui/icons-material/LocalConvenienceStore';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import CategoryIcon from '@mui/icons-material/Category';
import MoneyOffCsredIcon from '@mui/icons-material/MoneyOffCsred';
import BalanceIcon from '@mui/icons-material/Balance';
import ListAltIcon from '@mui/icons-material/ListAlt';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import DateRangeIcon from '@mui/icons-material/DateRange';
import DomainDisabledIcon from '@mui/icons-material/DomainDisabled';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import ReorderIcon from '@mui/icons-material/Reorder';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import MovingIcon from '@mui/icons-material/Moving';
import InventoryIcon from '@mui/icons-material/Inventory';
export const iconsRegistry = {
  'Administration.OrganizationUnits': BusinessIcon,
  'Dashboard': DashboardIcon,
  'Dashboard.Tenant': DashboardIcon,
  'Editions': GridViewIcon,
  'Administration': AdminPanelSettingsIcon,
  'Tenants': BusinessCenterIcon,
  'Administration.Roles': SupervisedUserCircleIcon,
  'Administration.Users': FingerprintIcon,
  'Administration.Languages': LanguageIcon,
  'Administration.AuditLogs':AudioFileIcon,
  'Administration.Maintenance': CleaningServicesIcon,
  'Administration.Settings.Host': SettingsIcon,
  'Administration.Settings.Tenant': SettingsIcon,
  'Administration.Settings.Jobs': DeveloperBoardIcon,
  'Banking': AccountBalanceIcon,
  'Banking.Receipts/Transfers': CurrencyExchangeIcon,
  'Banking.ACH': LocalAtmIcon,
  'Banking.BankReconciliation': DoneOutlineIcon,
  'Banking.BankMaintenance': AssuredWorkloadIcon,
  'Banking.Inquiry': AccountBalanceWalletIcon,
  'Banking.Receipts.Inquiry': CurrencyExchangeIcon,
  'Banking.Inquiry.DepositAnalysis': PaymentsIcon,
  'Reporting': AssessmentIcon,
  'Banking.Reporting.ReceiptsAndDisbursements': CurrencyExchangeIcon,
  'Banking.Reporting.DepositAnalysis': PaymentsIcon,
  'Banking.Reporting.DailyCashBalance': MonetizationOnIcon,
  'Banking.Currency': LocalConvenienceStoreIcon,
  'Financials': AttachMoneyIcon,
  'Financials.Accounts': BookOnlineIcon,
  'Financials.Accounts.ChartOfAccounts': PivotTableChartIcon,
  'Financials.Accounts.SubAccounts': AccountTreeIcon,
  'Financials.Accounts.Divisions': AlignVerticalBottomIcon,
  'Financials.Accounts.TypeofClassification': CategoryIcon,
  'Financials.Accounts.TaxRebate': MoneyOffCsredIcon,
  'Financials.Journals.Entry': NewspaperIcon,
  'Financials.Inquiry': AccountBalanceWalletIcon,
  'Financials.Inquiry.TrialBalance': BalanceIcon,
  'Financials.Inquiry.BalanceSheet': ListAltIcon,
  'Financials.Inquiry.IncomeStatement': MoveToInboxIcon,
  'Financials.Inquiry.JournalHistory': NewspaperIcon,
  'Financials.Inquiry.AssetTracking': WebAssetIcon,
  'Financials.FiscalPeriod': DateRangeIcon,
  'Financials.Reporting.TrialBalance': BalanceIcon,
  'Financials.Reporting.BalanceSheet': ListAltIcon,
  'Financials.Reporting.IncomeStatement': MoveToInboxIcon,
  'Financials.Reporting.LedgerReport': NewspaperIcon,
  'Financials.Reporting.FinancialReporting':ListAltIcon,
  'Financials.Reporting.LineOfBusiness':DomainDisabledIcon,
  'Projects': MovieIcon,
  'Projects.ProjectMaintenance': MovieFilterIcon,
  'Projects.ProjectMaintenance.Projects': MovieIcon,
  'Projects.ProjectMaintenance.ProjectCOAs':PivotTableChartIcon,
  'Projects.Inquiry':AccountBalanceWalletIcon,
  'Projects.Inquiry.JobLineSummary':ReorderIcon,
  'Projects.Inquiry.ProjectLedgerTransactions':NewspaperIcon,
  'Projects.Inquiry.ProfitWorksheetSelection':MovingIcon,
  'Projects.Inquiry.ProjectSummary':SignalCellularAltIcon,
  'Projects.Inquiry.JobSummaryByLineNo':ReorderIcon,
  'Projects.Reporting.ProductionCost':InventoryIcon,
  'Projects.Reporting.ProjectLedger':NewspaperIcon,
  'Projects.Reporting.JobCost':RequestQuoteIcon,
  'Projects.TotalingEngine':AccountTreeIcon,
  'Payables': GroupsIcon,
  'PurchaseOrders': ShoppingCartIcon,
  'Receivables': ReceiptLongIcon,
  'PettyCash': RequestQuoteIcon,
  'CreditCard': CreditCardIcon,
  'Payroll': PaymentsIcon,
  'BatchPosting': FolderZipIcon
};